import {useCallback} from "react";
import Particles from "react-tsparticles";
import {loadFull} from "tsparticles";
// import DataContext from "../context/DataContext";
// import particlesConfig from "./particlesjs-config";

export function NetworkBackground() {
  const particlesInit = useCallback(async (main) => {
    await loadFull(main);
  }, []);

  return (
    <div id="particles-container">
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={{
          fullScreen: {
            enable: true,
            zIndex: -1, // sits above gradient
          },
          background: {
            color: {
              value: "transparent",
            },
          },
          particles: {
            number: {value: 70},
            color: {value: "#fff"},
            shape: {type: "circle"},
            opacity: {value: 0.8},
            size: {value: 4},
            rotate: {
              value: 0,
              random: true,
              direction: "clockwise",
              animation: {
                enable: true,
                speed: 5,
              },
            },
            line_linked: {
              enable: true,
              distance: 200,
              color: "#ffffff",
              opacity: 0.4,
              width: 2,
            },
            move: {
              enable: true,
              speed: 2,
              out_mode: "out",
            },
          },
          interactivity: {
            events: {
              onhover: {enable: true, mode: ["grab"]},
              onclick: {enable: false},
              resize: true,
            },
            modes: {
              grab: {
                distance: 300,
                line_linked: {opacity: 1},
              },
            },
          },
          retina_detect: true,
        }}
      />
    </div>
  );
}
